<header
  class="fixed w-full top-0 z-50 bg-gray-900/5 backdrop-blur-md border-b border-white/10 p-3 sm:px-6 transition-all duration-300"
>
  <nav class="relative flex flex-row items-center w-full max-w-7xl mx-auto gap-2 px-1 sm:px-0">
    <div class="flex items-center gap-3 text-white font-semibold shrink-0">
      <img
        src="/img/imagotipo-blanco.png"
        alt="VentaClick"
        class="transition-all duration-300 w-28 sm:w-32 md:w-36 lg:w-40 cursor-pointer"
      />
    </div>

    <ul
      class="flex justify-end md:justify-center gap-4 sm:gap-6 text-sm list-none text-slate-200 font-medium md:text-base md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:gap-5 whitespace-nowrap ml-auto"
    >
      <li>
        <a (click)="scrollTo('hero')" class="hover:text-blue-400 transition cursor-pointer"
          >Inicio</a
        >
      </li>
      <li class="hidden md:block">
        <a (click)="scrollTo('features')" class="hover:text-blue-400 transition cursor-pointer"
          >Características</a
        >
      </li>
      <li class="hidden md:block">
        <a (click)="scrollTo('advantages')" class="hover:text-blue-400 transition cursor-pointer"
          >Ventajas</a
        >
      </li>
      <li class="hidden md:block">
        <a (click)="scrollTo('plans')" class="hover:text-blue-400 transition cursor-pointer"
          >Precios</a
        >
      </li>
      <li>
        <a (click)="scrollTo('contact')" class="hover:text-blue-400 transition cursor-pointer">
          Contacto
        </a>
      </li>
      <li class="relative">
        <!-- (click)="showLogin.set(!showLogin())" -->
        <!-- <a routerLink="/auth/login" class="hover:text-blue-400 transition cursor-pointer"> -->
        <a
          (click)="showLogin.set(!showLogin())"
          class="hover:text-blue-400 transition cursor-pointer"
        >
          Iniciar Sesión
        </a>
        <!-- cuando de se click fuera que no muestre login -->
        @if (showLogin() === true) {
          <div
            class="absolute right-0 mt-2 bg-gray-800 rounded-lg shadow-lg p-4 z-50 animate-fade-in"
            (clickOutside)="showLogin.set(false)"
          >
            <app-auth-login />
          </div>
        }
      </li>
    </ul>
  </nav>
</header>

<!-- grid-bg -->
<main class="min-h-screen grid-bg bg-slate-950 relative overflow-hidden pt-20">
  <!-- Animated blob backgrounds -->
  <div class="absolute inset-0 opacity-20 pointer-events-none">
    <div
      class="absolute top-20 left-20 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob"
    ></div>
    <div
      class="absolute top-40 right-20 w-72 h-72 bg-[#0080f3] rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"
    ></div>
    <div
      class="absolute bottom-20 left-1/2 w-72 h-72 bg-[#0ea5e9] rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"
    ></div>
  </div>

  <section id="hero" class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
    <div class="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      <!-- Left content -->
      <div class="text-white">
        <!-- Badge with pulse -->
        <div
          class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/20 backdrop-blur-sm border border-blue-400/30 mb-6 animate-fade-in"
        >
          <span class="relative flex h-2 w-2">
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"
            ></span>
            <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          <span class="text-sm">Sistema POS de última generación</span>
        </div>

        <!-- Main heading -->
        <h1
          class="mb-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight bg-linear-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent"
        >
          El Punto de Venta inteligente diseñado para el futuro de tu negocio
        </h1>

        <!-- Description -->
        <p class="text-base sm:text-lg md:text-xl text-blue-100 mb-8 leading-relaxed">
          Controla tu negocio desde cualquier lugar: ventas, stock, usuarios y reportes en tiempo
          real con tecnología moderna y segura.
        </p>

        <!-- Buttons -->
        <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-8">
          <a
            href="#demo"
            class="group px-6 sm:px-8 py-3 sm:py-4 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] rounded-lg sm:rounded-xl hover:shadow-2xl hover:shadow-[#0080f3]/50 transition-all duration-300 flex items-center justify-center gap-2 text-white font-semibold text-sm sm:text-base"
          >
            <i class="bi bi-play-fill"></i>
            <span>Probar Demo</span>
          </a>

          <a
            href="#plans"
            class="px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg sm:rounded-xl hover:bg-white/20 transition-all duration-300 text-white font-semibold text-sm sm:text-base"
          >
            Ver Planes
          </a>
        </div>

        <!-- Stats -->
        <div class="grid grid-cols-3 gap-4 sm:gap-8">
          <div>
            <div
              class="text-2xl sm:text-3xl mb-1 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] bg-clip-text text-transparent font-bold"
            >
              99.9%
            </div>
            <div class="text-xs sm:text-sm text-blue-200">Activo y estable</div>
          </div>
          <div>
            <div
              class="text-2xl sm:text-3xl mb-1 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] bg-clip-text text-transparent font-bold"
            >
              20+
            </div>
            <div class="text-xs sm:text-sm text-blue-200">Clientes activos</div>
          </div>
          <div>
            <div
              class="text-2xl sm:text-3xl mb-1 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] bg-clip-text text-transparent font-bold"
            >
              24/7
            </div>
            <div class="text-xs sm:text-sm text-blue-200">Soporte disponible</div>
          </div>
        </div>
      </div>

      <!-- Right content - Dashboard mockup -->
      <div class="relative hidden lg:block">
        <!-- Glow effect -->
        <div
          class="absolute -inset-4 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] rounded-2xl blur-2xl opacity-30"
        ></div>

        <!-- Dashboard image container -->
        <div
          class="relative bg-linear-to-br from-slate-800 to-slate-900 rounded-2xl p-2 shadow-2xl border border-white/10"
        >
          <img
            src="/img/mujervc.jpg"
            alt="Megatecs POS Dashboard"
            class="rounded-xl w-full h-auto shadow-2xl"
          />

          <!-- Floating card - Sales -->
          <div
            class="absolute -right-6 top-1/4 bg-white rounded-xl p-4 shadow-xl hidden lg:block animate-float-up"
            style="animation-duration: 3s"
          >
            <div class="text-sm text-gray-600 mb-1">📈 Ventas Hoy</div>
            <div
              class="text-2xl bg-linear-to-r from-[#0080f3] to-[#0ea5e9] bg-clip-text text-transparent font-bold"
            >
              $12,450
            </div>
            <div class="text-xs text-green-500 mt-1">+23.5%</div>
          </div>

          <!-- Floating card - Transactions -->
          <div
            class="absolute -left-6 bottom-1/4 bg-white rounded-xl p-4 shadow-xl hidden lg:block animate-float-down"
            style="animation-duration: 4s"
          >
            <div class="text-sm text-gray-600 mb-1">💵 Transacciones</div>
            <div
              class="text-2xl bg-linear-to-r from-[#0080f3] to-[#0ea5e9] bg-clip-text text-transparent font-bold"
            >
              847
            </div>
            <div class="text-xs text-blue-500 mt-1">En tiempo real</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll indicator -->
    <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
      <div
        class="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-2"
      >
        <div class="w-1.5 h-1.5 rounded-full bg-white animate-scroll"></div>
      </div>
    </div>
  </section>

  <section id="features" class="relative z-10 py-20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-white">
        Características principales
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition"
        >
          <i class="bi bi-cart-check text-2xl text-blue-400 mb-4"></i>
          <h3 class="text-xl font-bold text-white mb-3">Gestión de Ventas</h3>
          <p class="text-blue-100">
            Procesa ventas rápidamente con interfaz intuitiva y flujo optimizado.
          </p>
        </div>
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition"
        >
          <i class="bi bi-boxes text-2xl text-cyan-400 mb-4"></i>
          <h3 class="text-xl font-bold text-white mb-3">Control de Stock</h3>
          <p class="text-blue-100">
            Monitorea tu inventario en tiempo real con alertas automáticas.
          </p>
        </div>
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition"
        >
          <i class="bi bi-file-earmark-pdf text-2xl text-[#0080f3] mb-4"></i>
          <h3 class="text-xl font-bold text-white mb-3">Reportes Automáticos</h3>
          <p class="text-blue-100">Genera reportes detallados de ventas, productos y finanzas.</p>
        </div>
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition"
        >
          <i class="bi bi-people text-2xl text-green-400 mb-4"></i>
          <h3 class="text-xl font-bold text-white mb-3">Gestión de Usuarios</h3>
          <p class="text-blue-100">Administra roles y permisos para tu equipo de trabajo.</p>
        </div>
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition"
        >
          <i class="bi bi-percent text-2xl text-orange-400 mb-4"></i>
          <h3 class="text-xl font-bold text-white mb-3">Caja y Descuentos</h3>
          <p class="text-blue-100">
            Control completo de caja, descuentos especiales y promociones.
          </p>
        </div>
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition"
        >
          <i class="bi bi-clock-history text-2xl text-yellow-400 mb-4"></i>
          <h3 class="text-xl font-bold text-white mb-3">Turnos y Pagos</h3>
          <p class="text-blue-100">
            Gestiona turnos de empleados y pagos pendientes eficientemente.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Ventajas Competitivas Section -->
  <section id="advantages" class="relative z-10 py-20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4">
          Ventajas Competitivas
        </h2>
        <p class="text-lg sm:text-xl text-blue-100 mb-2">La solución que tu negocio necesita</p>
        <p class="text-base sm:text-lg text-slate-300">
          Tecnología de última generación al servicio de tu crecimiento
        </p>
      </div>

      <!-- Benefits Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-16">
        <!-- Interfaz Intuitiva -->
        <div
          class="bg-linear-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:border-[#0080f3]/50 transition"
        >
          <div class="flex items-start gap-4 mb-4">
            <div class="shrink-0">
              <div class="flex items-center justify-center h-12 w-12 rounded-lg bg-[#0080f3]/20">
                <i class="bi bi-cursor text-2xl text-[#0080f3]"></i>
              </div>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white mb-1">Interfaz Intuitiva y Fácil de Usar</h3>
              <p class="text-sm text-green-400 font-semibold">5 min de capacitación</p>
            </div>
          </div>
          <p class="text-blue-100 leading-relaxed">
            Diseño centrado en el usuario que minimiza la curva de aprendizaje. Tu equipo estará
            operando en minutos.
          </p>
        </div>

        <!-- Rápido, Estable y Seguro -->
        <div
          class="bg-linear-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:border-[#0080f3]/50 transition"
        >
          <div class="flex items-start gap-4 mb-4">
            <div class="shrink-0">
              <div class="flex items-center justify-center h-12 w-12 rounded-lg bg-cyan-400/20">
                <i class="bi bi-shield-check text-2xl text-cyan-400"></i>
              </div>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white mb-1">Rápido, Estable y Seguro</h3>
              <p class="text-sm text-green-400 font-semibold">99.9% uptime</p>
            </div>
          </div>
          <p class="text-blue-100 leading-relaxed">
            Arquitectura moderna con encriptación de datos, respaldos automáticos y máxima
            disponibilidad.
          </p>
        </div>

        <!-- Multi-dispositivo -->
        <div
          class="bg-linear-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:border-[#0080f3]/50 transition"
        >
          <div class="flex items-start gap-4 mb-4">
            <div class="shrink-0">
              <div class="flex items-center justify-center h-12 w-12 rounded-lg bg-purple-400/20">
                <i class="bi bi-phone text-2xl text-purple-400"></i>
              </div>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white mb-1">Multi-dispositivo</h3>
              <p class="text-sm text-green-400 font-semibold">100% responsive</p>
            </div>
          </div>
          <p class="text-blue-100 leading-relaxed">
            Compatible con PC, laptops y tablets. Accede desde cualquier lugar con sincronización
            instantánea.
          </p>
        </div>

        <!-- Arquitectura Escalable -->
        <div
          class="bg-linear-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:border-[#0080f3]/50 transition"
        >
          <div class="flex items-start gap-4 mb-4">
            <div class="shrink-0">
              <div class="flex items-center justify-center h-12 w-12 rounded-lg bg-blue-400/20">
                <i class="bi bi-diagram-3 text-2xl text-blue-400"></i>
              </div>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white mb-1">Arquitectura Escalable</h3>
              <p class="text-sm text-green-400 font-semibold">Ilimitado</p>
            </div>
          </div>
          <p class="text-blue-100 leading-relaxed">
            Crece sin límites. Desde pequeños negocios hasta grandes cadenas de retail y
            restaurantes.
          </p>
        </div>
      </div>

      <!-- Industries Section -->
      <div class="border-t border-white/10 pt-16">
        <div class="text-center mb-12">
          <h2 class="text-3xl sm:text-4xl font-bold text-white mb-3">
            Perfecto para todo tipo de negocio
          </h2>
          <p class="text-base sm:text-lg text-slate-300">
            Solución versátil adaptable a múltiples industrias
          </p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          <div
            class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 text-center hover:bg-white/10 transition"
          >
            <i class="bi bi-shop text-3xl text-[#0080f3] mb-3 block"></i>
            <h4 class="text-lg font-bold text-white">Retail</h4>
          </div>
          <div
            class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 text-center hover:bg-white/10 transition"
          >
            <i class="bi bi-cup-hot text-3xl text-cyan-400 mb-3 block"></i>
            <h4 class="text-lg font-bold text-white">Restaurantes</h4>
          </div>
          <div
            class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 text-center hover:bg-white/10 transition"
          >
            <i class="bi bi-bag-check text-3xl text-green-400 mb-3 block"></i>
            <h4 class="text-lg font-bold text-white">Tiendas</h4>
          </div>
          <div
            class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 text-center hover:bg-white/10 transition"
          >
            <i class="bi bi-prescription2 text-3xl text-red-400 mb-3 block"></i>
            <h4 class="text-lg font-bold text-white">Farmacias</h4>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="plans" class="relative z-10 py-20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-white">
        Precios y Planes
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
        <!-- Plan 2: Restaurante -->
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-8 hover:border-[#0080f3]/50 transition"
        >
          <div class="flex items-center gap-2 mb-3">
            <span class="text-2xl">⭐</span>
            <span class="text-sm font-bold text-blue-300">PLAN 2 – Restaurantes</span>
          </div>
          <h3 class="text-2xl font-bold text-white mb-1">Plan Restaurante</h3>
          <p class="text-blue-200 mb-6 text-sm">
            Optimizado para restaurantes, cafeterías y food trucks.
          </p>
          <div class="text-4xl font-bold text-white mb-6">
            S/ 150<span class="text-lg text-blue-300">/mes</span>
          </div>
          <div class="mb-8 pb-8 border-b border-white/10">
            <p class="text-xs text-slate-400 font-semibold uppercase mb-4">Incluye:</p>
            <ul class="space-y-2 text-blue-100 text-sm">
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🍽️</span>
                <span>Sistema de comandas digitales</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🍽️</span>
                <span>Gestión de hasta 10 mesas</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">📲</span>
                <span>Flujo rápido para toma de pedidos</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🧾</span>
                <span>Finalización con boleta o factura electrónica</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">👥</span> <span>5 usuarios activos</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">📊</span>
                <span>Reportes avanzados (ventas y caja)</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">💬</span> <span>Soporte 24/7</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🎓</span>
                <span>Capacitación incluida</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🔄</span>
                <span>Actualizaciones automáticas</span>
              </li>
            </ul>
          </div>
          <button
            class="w-full px-4 sm:px-6 py-2 text-xs sm:text-sm md:text-base bg-white/10 border border-white/20 rounded-lg hover:bg-white/20 text-white transition"
          >
            Comenzar
          </button>
        </div>

        <!-- Plan 1: Retail - POPULAR (Centro) -->
        <div
          class="bg-linear-to-br from-[#0080f3]/20 to-[#0ea5e9]/20 backdrop-blur-sm border border-[#0080f3]/50 rounded-xl p-4 sm:p-8 relative overflow-hidden group"
        >
          <div
            class="absolute top-0 right-0 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] px-4 py-1 rounded-bl-lg text-white text-xs font-bold"
          >
            POPULAR
          </div>
          <div class="flex items-center gap-2 mb-3">
            <span class="text-2xl">⭐</span>
            <span class="text-sm font-bold text-blue-300">PLAN 1 – Punto de Venta</span>
          </div>
          <h3 class="text-2xl font-bold text-white mb-1">Plan Básico POS</h3>
          <p class="text-blue-200 mb-6 text-sm">
            Ideal para tiendas, boutiques, minimarkets y negocios retail.
          </p>
          <div class="text-4xl font-bold text-white mb-6">
            S/ 150<span class="text-lg text-blue-300">/mes</span>
          </div>
          <div class="mb-8 pb-8 border-b border-white/20">
            <p class="text-xs text-slate-300 font-semibold uppercase mb-4">Incluye:</p>
            <ul class="space-y-2 text-blue-100 text-sm">
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">📦</span>
                <span>Hasta 1,000 productos</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🏪</span> <span>1 punto de venta</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">👥</span> <span>5 usuarios activos</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">📊</span>
                <span>Reportes avanzados (Ventas, Caja, Movimientos)</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🧾</span>
                <span>Integración con SUNAT (boletas y facturas)</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">💰</span>
                <span>Gestión de créditos y pagos pendientes</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">💬</span>
                <span>Soporte 24/7 por WhatsApp</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🎓</span>
                <span>Capacitación inicial incluida</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🔄</span>
                <span>Actualizaciones automáticas</span>
              </li>
            </ul>
          </div>
          <button
            class="w-full px-4 sm:px-6 py-2 text-xs sm:text-sm md:text-base bg-linear-to-r from-[#0080f3] to-[#0ea5e9] rounded-lg hover:shadow-lg hover:shadow-[#0080f3]/50 text-white transition"
          >
            Comenzar
          </button>
        </div>

        <!-- Plan 3: Centro Infantil - Normal -->
        <div
          class="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-8 hover:border-[#0080f3]/50 transition"
        >
          <div class="flex items-center gap-2 mb-3">
            <span class="text-2xl">⭐</span>
            <span class="text-sm font-bold text-blue-300">PLAN 3 – Centro de Juegos</span>
          </div>
          <h3 class="text-2xl font-bold text-white mb-1">Plan Centro Infantil</h3>
          <p class="text-blue-200 mb-6 text-sm">
            Diseñado para playgrounds, zonas infantiles y centros de entretenimiento.
          </p>
          <div class="text-4xl font-bold text-white mb-6">
            S/ 150<span class="text-lg text-blue-300">/mes</span>
          </div>
          <div class="mb-8 pb-8 border-b border-white/10">
            <p class="text-xs text-slate-400 font-semibold uppercase mb-4">Incluye:</p>
            <ul class="space-y-2 text-blue-100 text-sm">
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🎈</span>
                <span>Control de tiempo por sesión</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">⏱️</span>
                <span>Reloj integrado con alertas visuales</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">👥</span>
                <span>Registro rápido de niños y grupos</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🧾</span>
                <span>Finalización con boleta o factura electrónica</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">📊</span>
                <span>Reportes básicos de ingresos y sesiones</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">💬</span>
                <span>Soporte 24/7 por WhatsApp</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🎓</span>
                <span>Capacitación incluida</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-green-400 shrink-0">🔄</span>
                <span>Actualizaciones automáticas</span>
              </li>
            </ul>
          </div>
          <button
            class="w-full px-4 sm:px-6 py-2 text-xs sm:text-sm md:text-base bg-white/10 border border-white/20 rounded-lg hover:bg-white/20 text-white transition"
          >
            Comenzar
          </button>
        </div>
      </div>
    </div>
  </section>

  <section id="contact" class="relative z-10 py-20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-white">¿Tienes dudas?</h2>
      <p class="text-base sm:text-lg md:text-xl text-blue-100 mb-8">
        Nuestro equipo está aquí para ayudarte. Contáctanos en
        <a href="mailto:info@ventaclick.com" class="text-blue-400 hover:text-blue-300 underline"
          >info@ventaclick.com</a
        >
      </p>
      <a
        href="#demo"
        class="inline-block px-4 sm:px-8 py-2 sm:py-4 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] rounded-lg sm:rounded-xl text-white font-semibold text-xs sm:text-base hover:shadow-lg hover:shadow-[#0080f3]/50 transition"
      >
        Comenzar ahora
      </a>
    </div>
  </section>
</main>
